// extracted by mini-css-extract-plugin
export default {"wrapper":"MezzaOverview_wrapper__qNj4l"};